import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Modal } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { FLAG_LIST } from '../constants';

const LanguagePopup = (props) => {
    const { setIsModalOpen, isModalOpen } = props;
    const { langList, changeLanguage, lang } = useLanguage();

    const onContinueClickHandler = (language) => {
        changeLanguage(language, true);
        setIsModalOpen(false);
    };
    return (
        <Modal
            title='Select language'
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            rootClassName='language-modal'
            centered
            width='22rem'
            cancelButtonProps={{
                hidden: true,
            }}
            okButtonProps={{ hidden: true }}
        >
            <div className='flex flex-col w-full gap-4'>
                {langList.map((item) => (
                    <div
                        key={item.id}
                        className={
                            'flex justify-between items-center border px-4 w-full py-4 rounded-lg text-white ' +
                            (item.lang_code === lang
                                ? 'border bg-green-100 border-green-200 text-black'
                                : '')
                        }
                        onClick={() => onContinueClickHandler(item.lang_code)}
                    >
                        <span
                            className={
                                'flex justify-start items-center text-2xl gap-2 ' +
                                (item.lang_code === lang ? ' text-black' : '')
                            }
                        >
                            <span className='text-4xl font-semibold text-white'>
                                {FLAG_LIST[item.lang_code.toUpperCase()]}{' '}
                            </span>
                            {item.lang_name}
                        </span>
                        {item.lang_code === lang && (
                            <span className='text-2xl'>
                                <CheckCircleTwoTone twoToneColor='green' />
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </Modal>
    );
};
export default LanguagePopup;
